module.exports = __webpack_public_path__ + "img/sample_05_big.8e4252f0.gif";